<template>
  <QuestionBase :question="question" :errors="[...serverErrors, ...jsErrors]" :valid="!!data">
    <InputSelect
        v-model="data"
        :db="db"
        :args="args"
        :skipped="skipped"
        :options="changesRelationshipOptions"
        @skipped="skipped=$event"
        @serverErrors="serverErrors=$event"
        @jsErrors="jsErrors=$event"
    />
  </QuestionBase>
</template>

<script>
import { questionLoadHelpers } from "../../../../helpers/questionLoadHelpers";
import { estatePlanningSurveyOptions } from "../../../../options/estatePlanningSurveyOptions";

import QuestionBase from "../../../../QuestionBase";
import InputSelect from "../../../../inputs/InputSelect";

export default {
  name: 'ExistingWillChangesRelationshipDetails',
  mixins: [questionLoadHelpers, estatePlanningSurveyOptions],
  components: {
    InputSelect,
    QuestionBase
  },
  props: {
    value: {
      type: String,
      required: false
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      }
    }
  },
  data () {
    return {
      question: {
        title:  'What has changed with your relationship status since your Will was executed?',
        subTitle:  'If more than one thing has changed (for example if you have divorced and re-married), please select the option that best reflects your current situation',
        tip: null
      },
      db: {
        saveLocation: 'estate_planning_survey_save',
        saveField: 'changes_relationship_details'
      },
      args: {
        placeholder: 'Please Select',
        label: null,
        skippable: false,
        required: true,
        inputClass: 'field-50'
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>